import { render } from "./ThreeRandselInside.vue?vue&type=template&id=63dae14d&ts=true"
import script from "./ThreeRandselInside.vue?vue&type=script&lang=ts"
export * from "./ThreeRandselInside.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/gerald/Projects/designium/RandselSimulation/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__